import React, { useState, useEffect, useRef } from "react";
import styled from "styled-components";

const FooterComponent = () => {
  return (
    <Style>
      <div className="footerWrap">
        <img
          src={`${process.env.PUBLIC_URL}/svg/logo_white.svg`}
          alt="behind 로고"
          className="behindLogo"
        />
        <div className="companyInfoWrap">
          <p>(주)인비저블아이디어</p>
          <p>대표자: 윤언식 사업자등록번호: 159-86-01794</p>
          <p>대표번호: 1670-5324 이메일: behind@ivid.kr</p>
          <p>주소: 대구 북구 호암로 51, 메이커스페이스동 2층 (본사) </p>
          <p>서울 강남구 선릉로 622, 대영빌딩 2층 (연구소)</p>
          <p>ⓒ2025 Behind Inc. All Rights Reserved</p>
        </div>
      </div>
    </Style>
  );
};
export default FooterComponent;

const Style = styled.div`
  /* headerWrap */
  .footerWrap {
    width: 100%;
    padding: 86px 360px;
    background: #262626;

    img {
      width: 190px;
    }
  }

  /* companyInfoWrap */
  .companyInfoWrap {
    margin-top: 171px;

    p {
      margin-bottom: 8px;
      font-size: 16px;
      font-weight: 500;
      color: #979797;
      line-height: 24px;
    }
  }
  @media (max-width: 1500px) {
    .footerWrap {
      padding: 86px;
    }
  }
  @media (max-width: 1100px) {
    .footerWrap {
      padding: 73px 20px;

      img {
        width: 59px;
      }
    }
    .companyInfoWrap {
      margin-top: 81px;

      p {
        margin-bottom: 5px;
        font-size: 10px;
        line-height: 15px;
      }
    }
  }
`;
